<template>
  <div>
    <div class="pagehead-area">
      <div class="head-area-item">
        <div class="head-area-item__label ant-col-5">网站名称：</div>
        <div class="head-area-item__text">{{ $route.query.platform_name }}</div>
      </div>
      <div class="head-area-item">
        <div class="head-area-item__label ant-col-5">网站域名：</div>
        <div class="head-area-item__text sty-blue">{{ $route.query.domain }}</div>
      </div>
    </div>
    <!-- 搜索 -->
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="页面名称">
            <a-input v-model="searchForm.page_title" allowClear placeholder="输入关键词" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <div class="operbtnbox">
            <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
            <a-button type="primary" icon="delete" ghost style="margin-right: 20px" @click="handleClear">重置</a-button>
            <a-button type="primary" icon="plus-circle" @click="addCacheSitePage">新增页面</a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>
    <!-- 表格 -->
    <a-table row-key="id" :loading="loading" :data-source="data" :pagination="pagination" class="mytable" @change="handleTableChange">
      <a-table-column title="页面名称" data-index="page_title" :width="360" align="center" />
      <a-table-column title="页面路径" data-index="page_route" align="center" />
      <a-table-column title="操作" :width="360" align="center" fixed="right">
        <template slot-scope="text, record">
          <a-button size="small" type="link" @click="openCacheSiteDetail(record)">缓存管理</a-button>
          <a-button size="small" type="link" @click="editCacheSitePage(record)">编辑</a-button>
          <a-button size="small" type="link" @click="cacheSiteClear(record)">清除缓存</a-button>
          <a-button size="small" type="link" class="deletebtn" @click="cacheSitePageDelete(record)">删除</a-button>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加缓存站点 -->
    <cacheSiteDetail v-if="visible" v-model="visible" :item-data="itemData" @handleOver="getList" />
    <!-- 新增缓存站点页面 -->
    <addCacheSitePage v-if="openCacheSitePage" v-model="openCacheSitePage" :isEdit="isEdit" :params="waitItem" :siteId="site_id" @handleOver="getList" />
  </div>
</template>

<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import pagination from '@/composables/pagination'
import api from '@/api/'
import cacheSiteDetail from './components/cacheSiteDetail'
import addCacheSitePage from './components/addCacheSitePage'
const searchForm = {
  project: '',
  type: '',
  platform_class: '',
  page_title: '',
  domain: ''
}
export default {
  components: { cacheSiteDetail, addCacheSitePage },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      searchForm: { ...searchForm },
      openCacheSitePage: false,
      // itemData: undefined
    })
    onMounted(async () => {
      if (_this.$route.query.project) {
        state.searchForm = {
          project: _this.$route.query.project,
          type: _this.$route.query.type,
          platform_class: _this.$route.query.platform_class,
          domain: _this.$route.query.domain,
        }
      }
      methods.getList()
    })
    const methods = {
      search() {
        _this.pagination.current = 1
        methods.getList()
      },
      async getList() {
        _this.loading = true
        const res = await api.cacheSitePageList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        if (res.code === '000000') {
          const { site, pagination } = res.data
          _this.data = site
          _this.pagination.total = pagination.total
        }
        _this.loading = false
      },
      handleClear() {
        state.searchForm.page_title = ''
        this.search()
      },
      addCacheSitePage() {
        state.openCacheSitePage = true
        _this.isEdit = false
        _this.waitItem = null
        _this.site_id = _this.$route.query.id
      },
      editCacheSitePage(data) {
        state.openCacheSitePage = true
        _this.isEdit = true
        _this.$nextTick(() => {
          _this.waitItem = { ...data }
        })
        _this.site_id = _this.$route.query.id
      },
      // 缓存清除
      cacheSiteClear(item) {
        this.$confirm({
          content: '缓存清除后不可恢复，确定要清除吗？',
          okText: "确定",
          cancelText: "取消",
          async onOk() {
            const res = await api.cacheSiteClear({ id: item.id, level: '2' })
            if (_this.$validate(res)) {
              if (res.code === '000000') {
                _this.$message.success('清除成功！')
                methods.getList()
              } else {
                _this.$message.error(res.message)
              }
            }
          }
        })
      },
      // 删除缓存站点页面
      cacheSitePageDelete(item) {
        this.$confirm({
          content: '删除后不可恢复，确定要删除吗？',
          okText: "确定",
          cancelText: "取消",
          async onOk() {
            const res = await api.cacheSitePageDelete({ id: item.id })
            if (_this.$validate(res)) {
              _this.$message.success('删除成功！')
              methods.getList()
            }
          }
        })
      },
      openCacheSiteDetail(item) {
        _this.itemData = item
        _this.visible = true
      }
    }
    return {
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>

<style scoped lang="less">
.pagehead-area {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #e8e8e8;

  .head-area-item {
    display: flex;
    align-items: center;
    min-width: 25%;
    line-height: 32px;
    padding: 0px 0 10px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);

    .head-area-item__label {
      text-align: right;
      font-weight: bold;
    }

    .head-area-item__text {
      &.sty-blue {
        color: #1890ff;
      }
    }
  }
}

.operbtnbox {
  padding: 4px 0;
}

.mytable {
  .deletebtn {
    color: #ff4d4f;

    &:hover {
      color: #ff7875;
    }
  }
}
</style>
